import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import {
  LineNotifyTargetsCreatePage,
  LineNotifyTargetsEditPage,
  LineNotifyTargetsPage,
} from '../lazyPages';

export const LineNotifyTargetsRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.LINE_NOTIFY_TARGETS')}>
            <LineNotifyTargetsPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="create"
        element={
          <GuardedPageRoute
            pageName={t('LINE_NOTIFY_TARGETS.FORM.CREATE_TITLE')}
            action="create"
          >
            <LineNotifyTargetsCreatePage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <GuardedPageRoute
            pageName={t('LINE_NOTIFY_TARGETS.FORM.EDIT_TITLE')}
            action="update"
          >
            <LineNotifyTargetsEditPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
